import Header from "../components/Header.js";
import Menu from "../components/Menu";
const AvailableMenu = () => {
    return (
        <>

        <Header/>

        <Menu/>


        </>
    )
}
export default AvailableMenu;